import { AuthService } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, EventEmitter, Output, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { GiftDescriptionComponent } from '../gift-description/gift-description.component';
import { GiftWishComponent } from '../gift-wish/gift-wish.component';
import { GiftPaymentComponent } from '../gift-payment/gift-payment.component';
import { RegistryService } from '../registry/registry.service';
import { GiftSelection } from '../gift/giftSelection';
import { Gift } from '../gift/gift';
import { Router, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from "../analytics/analytics.service";
import { Registry, Section } from "../registry/registry";
import { ImageUrlService } from '../shared/services/image-url.service';
@Component({

  selector: 'app-gift',
  templateUrl: './gift.component.html',
  styleUrls: ['./gift.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class GiftComponent implements OnInit {
  @Input() gift: Gift;
  @Input() isLoggedIn: boolean;
  @Input() oneOrMoreGiftSelectedForDelete: boolean;
  @Input() related: boolean;
  @Input() symbol: string;
  @Input() sectionName: string;
  @Input() crop: string;
  @Output() itemDeletedEvent: EventEmitter<any>;
  @Output() showImagePopupEvent: EventEmitter<any>;
  @Input() isEditMode: boolean;
  @Input() hasAnyGiftDeleting: boolean;
  @Input() isGiftSelectedForBulkDelete: boolean;

  @Input() isAnonymousCouple: boolean;
  @Input() isPopupOpen: boolean;
  @Output() imageClickedEvent: EventEmitter<any>;
  public backgroundColor: string;
  public giftSelection: GiftSelection;
  @Input() gifts: Gift[];
  canSeeLoops = true;
  @Input() showTranslation: boolean = false;
  public giftName: string;
  public sub: any;
  public registry: Registry;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  pricePerPortion = 0
  portionsRemaining = 0;
  constructor(
    private router: Router,
    private registryService: RegistryService,
    private _registryFirebaseService: RegistryFirebaseService,
    private analyticsService: AnalyticsService,
    private _authService: AuthService,
    private _cdr: ChangeDetectorRef,
    private imageUrlService: ImageUrlService
  ) {
    //
    this.itemDeletedEvent = new EventEmitter<any>();
    this.imageClickedEvent = new EventEmitter<any>();
    this.showImagePopupEvent = new EventEmitter<any>();



  }



  loadImageFailed() {
    // show message
  }

  deleteMode(e: Event, gift: Gift) {
    e.stopPropagation()
    gift.removing = true;

  }
  ngOnInit() {

    if (location.search.includes('showTranlsation')) {
      this.showTranslation = true;
    }
    if(this._cdr && !this._cdr['destroyed']){        
      this._cdr.detectChanges();      
   }
    this.registryService.showTranslationEmitted$.subscribe(x => {

      this.showTranslation = x;
    });


    // console.log('==========GIFT ONINIT==========', this.showTranslation);
    // this.registryService.showTranslationEmitted$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(x => {
    //     console.log('==========GIFT ONINIT 11111==========', this.showTranslation);
    //     this.showTranslation = x;
    //   });
    this._registryFirebaseService.currentRegistry.subscribe(registry => {

      this.registry = registry;
      this.canSeeLoops = this.registry && (!this.registry.paid || this.registry.tier != 'small')

      if(this._cdr && !this._cdr['destroyed']){        
        this._cdr.detectChanges();      
     }

    });

    if (this.gift && this.gift.portions) {
      this.pricePerPortion = this.registryService.getPortionsPricePerPortion(this.gift);
      this.portionsRemaining = this.registryService.getPortionsRemaining(this.gift);
    }
  }
  getParams() {
    const baseUrl = this.gift && this.gift.imageUrl ? this.gift.imageUrl : '';
    if (!this.gift.cropParams) {
      return this.imageUrlService.getStandardImageUrl(baseUrl).split('?')[1];
    } else {
      return this.imageUrlService.getStandardImageUrl(baseUrl).split('?')[1] + this.gift.cropParams;
    }
  }

  getVideoPosterUrl() {
    const imageUrl = this.gift && this.gift.imageUrl ? this.gift.imageUrl : '';
    return this.imageUrlService.getVideoPosterUrl(imageUrl);
  }

  getStandardImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
  close() {


    this.registryService.scrollToGift = this.gift.id;
    if (!this.isLoggedIn) {
      this.router.navigate(['/' + this.registry.registryName]);
    } else {
      this.router.navigate(['registry']);

    }
  }





  getGiftUrlWithoutHex() {
    if (this.gift && this.gift.imageUrl) {
      return this.registryService.cleanImageUrlRemoveHex(this.gift.imageUrl);
    }
    else {
      return ""
    }
  }
  color() {
    return this.registryService.getColor(this.gift.imageUrl);
  }
  showPopUpClicked() {

    this.showImagePopupEvent.emit();
  }

  imageClicked() {
    this.imageClickedEvent.emit();
  }
  moveToSection(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this._registryFirebaseService.showMoveGiftModal(this.gift);
  }
  share(url: string) {
    this.router.navigate(['/' + url.toLowerCase() + '/share']);
  }
  handleVideoError(event: Event, gift: Gift) {
    // Handle the video loading error
    console.error('Failed to load video: for ', gift.title, ' giftID:', gift.id);
    // Display a placeholder image or show an error message
  }
  duplicateGift(gift: Gift, event: Event) {

    event.stopPropagation();

    this._registryFirebaseService.duplicateGift(gift, this.gifts, this.registry, this.router, false, this.isAnonymousCouple)
  }
  toggleVideo(e: Event, giftWithVideo: Gift, isMobile = false) {
    e.stopPropagation();

    var videobuttons: any = document.getElementsByClassName('video_button');

    var videos: any = document.getElementsByClassName('pexels_video');
    var pausebuttons: any = document.getElementsByClassName('btn-pause');
    var playingButtons: any = document.getElementsByClassName('btn-play');

    if (pausebuttons) {
      Array.from(pausebuttons).forEach(element => {
        (element as any).style.display = "none";

      });
    }

    if (playingButtons) {
      Array.from(playingButtons).forEach(element => {
        (element as any).style.display = "block";
    
      });
    }




    var videoPlayer: any;

    if (isMobile) {
      videoPlayer = document.getElementById(giftWithVideo.videoUrl +"_" + giftWithVideo.id + "_mobile");
    } else {
      videoPlayer = document.getElementById(giftWithVideo.videoUrl +"_" + giftWithVideo.id);
    }

    let videoUrl = giftWithVideo.videoUrl +"_" + giftWithVideo.id
    if (isMobile) {
      videoUrl =giftWithVideo.videoUrl +"_" + giftWithVideo.id + "_mobile";
    }


    var currentPausebutton: any = document.getElementById(videoUrl + '_pause_button');
    var currentPlayButton: any = document.getElementById(videoUrl + '_play_button');
    if (videoPlayer.paused) {
      if (videos) {
        Array.from(videos).forEach(element => {

          (element as any).pause();
          //     (element as any).classList.add("paused");
        });
      }

      videoPlayer.play();

      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "block";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "none";
      }


    }
    else {
      videoPlayer.pause();
      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "none";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "block";
      }


    }
    // videoPlayer.classList.add("playing");


  }

  removeGift(e: Event) {
    e.stopImmediatePropagation();
    localStorage.removeItem('giftSelection');
    // this.analyticsService.trackEvent("delete-gift", this.gift);
    let giftId = this.gift.id;
    this._registryFirebaseService.removeGift(this.gift, this.registry);
    // refresh local gifts here
    this.itemDeletedEvent.emit(giftId);
    this.gift.removingConfirmed = true;
  }

  openOrEditGift(gift: Gift) {
    ;
    console.log('Gift before selection:', gift);
    console.log('Current editing state:', gift.editing);
  
    if (this.isLoggedIn) {
      this.editGift(gift);
    } else {
      this.openGift(gift);
    }
  }

  editGift(gift: Gift) {
    
    this.registryService.setScrollY(window.scrollY);
    if (!this.isLoggedIn) {
      return;
    }
    if (gift.status == 'paid') {
      return;
    }

    if(this.isLoggedIn && this.hasAnyGiftDeleting){
      return;
    }

    gift.editing = true;
    

    if (location.pathname.includes('/your-registry')) {
      return this.router.navigate(['/your-registry', gift.friendlyUrl.toLowerCase(), 'edit']);
    }

    return this.router.navigate(['/registry', gift.friendlyUrl.toLowerCase(), 'edit']);

  }
  pinGift(e: Event) {
    e.stopImmediatePropagation();
    this._registryFirebaseService.featureGift(this.gift.id, this.isAnonymousCouple);

  }

  switchImage(gift: Gift, e: Event) {
    e.stopImmediatePropagation();
    this._registryFirebaseService.switchImage(gift);
  }
  resetImage(gift: Gift, e: Event) {
    e.stopImmediatePropagation();
    this._registryFirebaseService.resetGiftImage(gift);
  }
  checkIfGiftIdExistsInOtherSection(giftId: string): Section {
    let giftExistsInSection = false;
    if (!this.registry.sections || this.registry.sections.length == 0) { return }

    this.registry.sections.forEach(section => {
      if (section.giftIds && section.giftIds.length > 0) {
        if (section.giftIds.includes(giftId)) {
          // section.giftIds = section.giftIds.filter(giftId => giftId !== giftId)
          giftExistsInSection = true;
          return section;

        }
      }
    })

  }
  swapElement(array, indexA, indexB) {
    // const tmp = array[indexA];
    // array[indexA] = array[indexB];
    // array[indexB] = tmp;
    array.splice(indexB, 0, array.splice(indexA, 1)[0]);


  }

  moveDown(e: Event) {
    e.stopImmediatePropagation();

    if (this.sectionName) {
      this.registry.sections.forEach(section => {
        if (section.name == this.sectionName) {
          let giftIndex = section.giftIds.findIndex(x => x == this.gift.id);
          if (giftIndex < section.giftIds.length - 1) {
            // Swap the current giftId with the one below it
            [section.giftIds[giftIndex], section.giftIds[giftIndex + 1]] = [section.giftIds[giftIndex + 1], section.giftIds[giftIndex]];
          }
        }
      });
      this._registryFirebaseService.saveRegistry(this.registry);
    }
    else {

      let currentIndex = this.gifts.findIndex(x => x.id == this.gift.id);

      if (currentIndex == this.gifts.length - 1) {
        return;
      }
      //if (this.registry.giftSort && !this.registry.giftSort.length ) {
      this.swapElement(this.gifts, currentIndex + 1, currentIndex);
      this.registry.giftSort = this.removeDuplicateUsingFilter(
        this.gifts.map(x => x.id)

      );
      this._registryFirebaseService.saveRegistry(this.registry);


      //}
    }
  }
  removeDuplicateUsingFilter(arr) {
    const unique_array = arr.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });

    return unique_array;
  }
  moveUp(e: Event) {
    e.stopImmediatePropagation();

    if (this.sectionName) {
      this.registry.sections.forEach(section => {
        if (section.name == this.sectionName) {
          let giftIndex = section.giftIds.findIndex(x => x == this.gift.id);
          if (giftIndex > 0) {
            // Swap the current giftId with the one above it
            [section.giftIds[giftIndex - 1], section.giftIds[giftIndex]] = [section.giftIds[giftIndex], section.giftIds[giftIndex - 1]];
          }
        }
      });

      this._registryFirebaseService.saveRegistry(this.registry);
    }

    else {

      let currentIndex = this.gifts.findIndex(x => x.id == this.gift.id);

      if (currentIndex == 0) {
        return;
      }
      //if (this.registry.giftSort && !this.registry.giftSort.length ) {
      this.swapElement(this.gifts, currentIndex - 1, currentIndex);
      this.registry.giftSort = this.removeDuplicateUsingFilter(
        this.gifts.map(x => x.id)

      );
      this._registryFirebaseService.saveRegistry(this.registry);


      //}
    }
  }
  openGift(gift: Gift) {
    

    ;
    if (gift.status == 'paid') {
      return;
    }


    if (gift.removingConfirmed) {
      return;
    }
    if (gift.paidPercent >= 100 && gift.removing) {
      return;
    }

    this.registryService.setScrollY(window.scrollY);

    if (!this.isLoggedIn) {
      this.router.navigate(['/' + this.registry.registryName, gift.friendlyUrl]);
    } else {
      this.router.navigate(['/registry', gift.friendlyUrl]);

    }

  }

  ngOnChanges() {
    

    if(!this.showTranslation && localStorage.getItem('showTranslation')){
      this.showTranslation = true;
    }

    if(this._cdr && !this._cdr['destroyed']){        
      this._cdr.detectChanges();      
   }
  
  }

}






// WEBPACK FOOTER //
// ./src/app/gift/gift.component.ts